"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogCloseButtonWidget = exports.CloseButtonWidget = void 0;
var tslib_1 = require("tslib");
var ClearBaseIcon_1 = require("@tableau/icons/ClearBaseIcon");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var Localize_1 = require("../../../gen-src/Localize");
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var ButtonWidget_1 = require("./ButtonWidget");
var ButtonWidgetShim_1 = require("./ButtonWidgetShim");
var CloseButtonStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    $nest: {
        '&&': { minHeight: 18, minWidth: 18, height: 18, width: 18, padding: 0 },
    }
});
exports.CloseButtonWidget = React.forwardRef(function (props, ref) {
    var useDarkStyling = props.useDarkStyling, buttonProps = tslib_1.__rest(props, ["useDarkStyling"]);
    return React.createElement(ButtonWidgetShim_1.ButtonWidget, tslib_1.__assign({}, buttonProps, { buttonType: useDarkStyling ? ButtonWidget_1.ButtonType.LowEmphasisDark : ButtonWidget_1.ButtonType.LowEmphasis, className: TypeStyle.classes(props.className, CloseButtonStyleName), ref: ref, title: props.title || Localize_1.Messages.close() }),
        React.createElement(ClearBaseIcon_1.ClearBaseIcon, { size: 14 }));
});
exports.CloseButtonWidget.displayName = 'CloseButtonWidget';
var TapTargetStyleName = TypeStyle.style({
    alignItems: 'center',
    backgroundClip: 'content-box',
    boxSizing: 'border-box',
    cursor: 'auto',
    display: 'flex',
    flexShrink: 0,
    height: 30,
    justifyContent: 'center',
    outline: 'none',
    padding: 6,
    width: 30,
    $nest: {
        '&:hover': { backgroundColor: '#aeaeae' },
        '&:active': { backgroundColor: '#939393' }, // this is the low emphasis button press background color
    }
});
exports.DialogCloseButtonWidget = React.forwardRef(function (props, ref) {
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    return React.createElement("div", tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { className: TapTargetStyleName, onClick: props.onClick, ref: ref }),
        React.createElement(exports.CloseButtonWidget, tslib_1.__assign({}, props, { "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'CloseButton'), onClick: function (e) { var _a; e.stopPropagation(); (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e); }, testId: null })));
});
exports.DialogCloseButtonWidget.displayName = 'DialogCloseButtonWidget';
//# sourceMappingURL=CloseButtonWidget.js.map